export default {"src":"/_next/static/media/BAC.17f8a3ce.svg","height":18,"width":18};